import React, { Component } from "react";
import { reduxForm } from "redux-form";
import Input from "../../../../components/form/Input";
import Button from "../../../../components/form/Button";
import CroField from "../../components/generalForm/CroField";
import { asyncForm } from "../../../../utils/asyncForm";
import { styles } from "../../index";
import { phoneWithCountryCode } from "../../../../utils/formValidation";

class UserForm extends Component {
  componentWillMount() {
    this.props.breadcrumbs(this.props.breadcrumbsItems);
  }

  render() {
    const { disabled, phoneDisabled, onSubmit, handleSubmit, submitting } = this.props;
    return (
      <form
        onSubmit={onSubmit ? handleSubmit(onSubmit) : undefined}
        className="cro-form long-label internalUserForm"
      >
        <div className="internalUserForm__section">
          <div className="internalUserForm__grid">
            <CroField
              className="half"
              title="Jméno"
              name="firstName"
              component={Input}
              fullWidth
              disabled={disabled}
            />
            <CroField
              className="half"
              title="Příjmení"
              name="lastName"
              component={Input}
              fullWidth
              disabled={disabled}
            />
            <CroField
              className="full"
              title="LDAP přihlašovací jméno"
              name="userDn"
              component={Input}
              fullWidth
              disabled={disabled}
            />
            <CroField
              className="half"
              title="Aktivní"
              name="activeLabel"
              component={Input}
              fullWidth
              disabled={true}
            />
            <CroField
              className="half"
              title="Telefon"
              name="phone"
              component={Input}
              fullWidth
              disabled={phoneDisabled}
              validate={[phoneWithCountryCode]}
            />
            <CroField
              className="half"
              title="Vytvořen"
              name="created"
              component={Input}
              fullWidth
              disabled={disabled}
            />
          </div>
        </div>

        <div className="internalUserForm__actions">
          <Button
            type="button"
            style={styles.buttons}
            label="Zpět"
            onClick={() =>
              this.props.router.goBack()
            }
          />
          {!phoneDisabled && onSubmit && (
            <Button
              type="submit"
              label="Uložit"
              style={styles.buttons}
              disabled={submitting}
              onClick={handleSubmit(onSubmit)}
            />
          )}
          {this.props.onShowHistory && (
            <Button
              type="button"
              style={styles.buttons}
              label="Zobrazit historii"
              onClick={this.props.onShowHistory}
            />
          )}
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: "internalUserForm",
  touchOnChange: true,
})(asyncForm(UserForm));
